module.exports = __webpack_public_path__ + "img/资产-考场标签.e0dbfd25.jpg";